import React from 'react'
import { FaLinkedinIn, FaFacebookF } from 'react-icons/fa'
import epharmaAuthorizerImg from './img/epharma-authorizer.png';
import ModalCookies from '../modalCookies';

const Footer = () => {
    return (
        <footer className="footer">
            <ModalCookies />
            <div className="container">
                <div className="footer__wrapper">
                    <div className="footer__item">
                        <h3>+55 11 4689-8686</h3>
                        <p>Al.Mamoré, 989 -9° andar - Alphaville - Barueri - SP</p>
                    </div>
                    <div className="footer__item-2">
                        <div className="footer__item-socials">
                            <a href="#" className="footer-link">
                                <FaLinkedinIn />
                            </a>
                            <a href="#" className="footer-link">
                                <FaFacebookF />
                            </a>
                        </div>
                        <img src={epharmaAuthorizerImg} alt="img-authorizer" />
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
